import React, { useContext } from 'react'
import Divider from 'LuxKit/Divider'
import Group from 'components/utils/Group'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import LineEnvelopeIcon from 'LuxKit/Icons/line/LineEnvelopeIcon'
import ContactContext from 'contexts/contactContext'
import config from 'constants/config'
import { SUPPORT_EMAIL_FOR_BRAND } from 'constants/support'

function BusinessTravellerAccountSupportItem() {
  const geoContact = useContext(ContactContext)
  const contact = geoContact.local
  const internationalContact = geoContact.international

  return <Group direction="vertical" gap={8}>
    <ClickableListItem
      href={`tel:${contact.number}`}
      rel="nofollow"
      title="Sales & Support"
      subtitle={contact.humanReadable}
      aria-label="Sales & Support"
      startIcon={<LinePhoneIcon />}
    />
    <ClickableListItem
      href={`tel:${internationalContact.number}`}
      aria-label="International Support Centre contact"
      rel="nofollow"
      title="International Support Centre"
      subtitle={internationalContact.humanReadable}
      startIcon={<LinePhoneIcon />}
    />
    <ClickableListItem
      aria-label="Email"
      rel="nofollow"
      title="Email"
      subtitle={SUPPORT_EMAIL_FOR_BRAND[config.BRAND]}
      startIcon={<LineEnvelopeIcon />}
    />
    <Divider kind="primary" />
  </Group>
}

export default BusinessTravellerAccountSupportItem
